<template>
  <div class="info-page">
    <main>
      <!-- Beispielbild (Aufbau angelehnt an routes/home.py des fasthtml_converter) -->
      <div class="hero-image-wrap">
        <img
          :src="screenshotUrl"
          alt="Beispiel einer Datenlandkarte im Grapheditor: Akteure, Anlagen und Datenquellen einer Fernwärme-Umstellung"
          class="hero-image"
        >
      </div>

      <!-- Feature Card mit Hover-Effekt und Pfeil -->
      <a href="#/editor" class="feature-card">
        <div class="feature-card-body">
          <div>
            <h5 class="feature-card-title">Grapheditor zum Erstellen von Datenlandkarten</h5>
            <p class="feature-card-subtitle">Hier klicken, um das Tool zu öffnen</p>
          </div>
          <div class="feature-card-arrow">→</div>
        </div>
      </a>

      <!-- Beschreibungstext -->
      <div class="description-card">
        <p>
          Mit dem Grapheditor erstellen Sie <strong>Datenlandkarten</strong>:
          Graphen, die den Datenaustausch rund um kommunale
          Energieeffizienzmaßnahmen sichtbar machen. Akteure, Datenquellen,
          technische Anlagen und rechtliche Grundlagen werden als Knoten
          modelliert und über Verbindungen in Beziehung gesetzt. Eine
          Datenlandkarte beantwortet damit vier zentrale Fragen:
        </p>
        <p>
          <strong>Wer kommuniziert mit wem?</strong>
          Die Karte macht den Datenaustausch zwischen den beteiligten
          Stakeholdern (z.B. Kommune, Energieversorger, Dienstleister)
          nachvollziehbar.
        </p>
        <p>
          <strong>Wo entstehen Daten?</strong>
          Technische Anlagen, Datenspeicher und Messkampagnen werden mitsamt
          ihren Datenflüssen dokumentiert.
        </p>
        <p>
          <strong>Welche Regeln gelten?</strong>
          Rechtliche und vertragliche Rahmenbedingungen lassen sich direkt in
          der Karte abbilden.
        </p>
        <p class="last">
          <strong>Was kostet der nächste Schritt?</strong>
          Verbindungen können mit Zeitaufwand und Kosten hinterlegt werden und
          unterstützen so die Planung von Energieeffizienzmaßnahmen.
        </p>
      </div>

      <div class="hint-card">
        <p>
          Alle Elemente können mit Markdown-Beschreibungen und Dateianhängen
          versehen werden. Karten werden automatisch lokal im Browser
          gespeichert und lassen sich als JSON-Datei exportieren, weitergeben
          und wieder importieren. Der schreibgeschützte View Mode eignet sich,
          um eine fertige Datenlandkarte gemeinsam mit anderen Beteiligten
          durchzugehen. Eine Schritt-für-Schritt-Anleitung finden Sie unter
          <a href="#/quickstart">Quickstart &amp; FAQ</a>.
        </p>
      </div>

      <PageFooter />
    </main>
  </div>
</template>

<script>
import PageFooter from './PageFooter.vue'
import screenshotUrl from '../assets/grapheditor-beispiel.png'
import '../styles/infopage.css'

export default {
  name: 'StartPage',
  components: {
    PageFooter
  },
  data() {
    return {
      screenshotUrl
    }
  }
}
</script>

<style scoped>
.hero-image-wrap {
  margin: 0 0 1.5rem;
}

.hero-image {
  width: 70%;
  display: block;
  margin: 0 auto;
  border: 1px solid #ddd;
  border-radius: 0.375rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 8px;
  background: white;
}

.feature-card {
  display: block;
  border: 1px solid rgba(0, 0, 0, 0.175);
  border-radius: 0.375rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
  color: #212529;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  text-decoration: none;
}

.feature-card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
}

.feature-card-title {
  font-size: 1.25rem;
  font-weight: 500;
  margin: 0 0 0.25rem;
}

.feature-card-subtitle {
  margin: 0;
  color: #6c757d;
}

.feature-card-arrow {
  font-size: 1.5rem;
  color: #0d6efd;
  margin-left: 1rem;
}

.description-card {
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.175);
  border-radius: 0.375rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.description-card p.last {
  margin-bottom: 0;
}

.hint-card {
  background: #f8f9fa;
  border: 1px solid rgba(0, 0, 0, 0.175);
  border-radius: 0.375rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.hint-card p {
  margin: 0;
}
</style>
